import { useCallback, useEffect } from "react";

import { config } from "config";

import { useUserInfo } from "../useUserInfo/useUserInfo";

declare global {
  interface Window {
    _walkmeConfig: unknown;
  }
}

export const walkMeScriptId = "walkme-script";

export const useInjectWalkme = () => {
  const { isAuthenticated, userId } = useUserInfo();

  const injectScript = useCallback(() => {
    const walkme = document.createElement("script");

    walkme.type = "text/javascript";
    walkme.async = true;
    walkme.src = config.WALKME_URL;
    walkme.setAttribute("id", walkMeScriptId);
    walkme.setAttribute("data-testid", walkMeScriptId);

    document.body.append(walkme);

    window._walkmeConfig = { smartLoad: true };
  }, []);

  useEffect(() => {
    const scriptExists = !!document.getElementById(walkMeScriptId);

    if (!scriptExists && userId && isAuthenticated) {
      injectScript();
    }
  }, [injectScript, userId, isAuthenticated]);
};
